import SingleCommView from "./SingleCommView";
export default SingleCommView;